import { render, staticRenderFns } from "./RankingField.vue?vue&type=template&id=c68e2082&"
import script from "./RankingField.vue?vue&type=script&lang=js&"
export * from "./RankingField.vue?vue&type=script&lang=js&"
import style0 from "./RankingField.vue?vue&type=style&index=0&id=c68e2082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports